// WithMessagePinData.jsx
import { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';

import getCurrentUnixTimestamp from '../resource/getCurrentUnixTimestamp.js';

import PinIconResource from '../../img/ic_pin_outline.svg';
import PinnedIconResource from '../../img/ic_pin.svg';

export const WithMessagePinData = ({
  messageId,
  meId,
  senderId,
  pinFeedAlias,
  profileFeedUnixTimestamp,
  pinnedItemIds,
  children,
  fetchFeeds,
  updateProfileFeedUnixTimestamp,
}) => {
  const isAuthor = useMemo(() => meId && meId === senderId, [meId, senderId]);
  // Update timestamp if author and timestamp not exist.
  useEffect(() => {
    if (isAuthor && !profileFeedUnixTimestamp) {
      updateProfileFeedUnixTimestamp({
        unixTimestamp: getCurrentUnixTimestamp(),
      });
    }
  }, [isAuthor, profileFeedUnixTimestamp, updateProfileFeedUnixTimestamp]);
  // Fetch feeds first page to generate pinned item ids
  useEffect(() => {
    fetchFeeds({
      type: pinFeedAlias,
      unixTimestamp: isAuthor ? profileFeedUnixTimestamp : undefined,
      shouldSkipLocalCache: true,
    });
  }, [pinFeedAlias, fetchFeeds, isAuthor, profileFeedUnixTimestamp]);
  const isPinned = useMemo(() => {
    return pinnedItemIds.includes(messageId);
  }, [messageId, pinnedItemIds]);
  return children({
    isPinned,
    iconSource: isPinned ? PinnedIconResource : PinIconResource,
  });
};

WithMessagePinData.propTypes = {
  messageId: PropTypes.string,
  meId: PropTypes.string,
  senderId: PropTypes.string,
  pinFeedAlias: PropTypes.string,
  profileFeedUnixTimestamp: PropTypes.number,
  pinnedItemIds: PropTypes.array,
  children: PropTypes.func,
  fetchFeeds: PropTypes.func,
  updateProfileFeedUnixTimestamp: PropTypes.func,
};

WithMessagePinData.defaultProps = {
  messageId: null,
  meId: null,
  senderId: null,
  pinFeedAlias: null,
  profileFeedUnixTimestamp: null,
  pinnedItemIds: [],
  children: () => null,
  fetchFeeds: () => null,
  updateProfileFeedUnixTimestamp: () => null,
};

export default WithMessagePinData;
